import {Box, Typography} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{height: "100%"}}
        >
            {value === index && (
                <Box sx={{ p: 3, padding: 0, height: "100%" }}>
                    <Typography style={{ height: "100% "}} component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};